import React, { FC } from "react";
import { BookingModal } from "../Booking/BookingModal/BookingModal";
import { BookingModal as BookingModalLegacy } from "../BookingLegacy/BookingModal/BookingModal";
import { BookingButtonViewModel } from "./BookingButtonViewModel.csharp";
import { useDecision } from "@optimizely/react-sdk";
import Modal from "react-modal";
import classNames from "classnames";
import {ModalThemeColor} from "../../../Model/ModalThemeColor.csharp";

interface BookingModalDecisionProps {
  bookingButton: BookingButtonViewModel;
  isModalOpened: boolean;
  ignorePersistedData?: boolean;
  closeModal: () => void;
}
export const BookingModalDecision: FC<BookingModalDecisionProps> = ({
  bookingButton,
  isModalOpened,
  closeModal,
  ignorePersistedData,
}) => {
  const [decision, clientReady] = useDecision(
    bookingButton.optimizelyExperimentation?.enableNewBookingFlowKey ?? ""
  );

  const getBookingVersion = () => {
    if (bookingButton.bookingVersion) {
      return bookingButton.bookingVersion === 1 ? oldBooking : newBooking;
    }
    if (bookingButton.useNewBookingFlow) {
      if (!clientReady) {
        return emptyBooking;
      }
      if (decision.enabled) {
        return newBooking;
      }
      return oldBooking;
    }
    return oldBooking;
  };

  const emptyBooking = (
      <Modal
          ariaHideApp={false}
          isOpen={isModalOpened}
          className={classNames("BookingModal", {
            "BookingModal--volvat":
                bookingButton.modalThemeColor == ModalThemeColor.Volvat,
            "BookingModal--nimi":
                bookingButton.modalThemeColor == ModalThemeColor.Nimi,
          })}
          overlayClassName="BookingModalOverlay"
          bodyOpenClassName="BookingModalBody--open"
      ></Modal>
  );

  const newBooking = (
      <BookingModal
          closeModal={closeModal}
          isOpen={isModalOpened}
          disableBooking={bookingButton.disableBooking}
          modalThemeColor={bookingButton.modalThemeColor}
          breadcrumbs={bookingButton.breadcrumbs}
          showCloseButton={bookingButton?.showCloseButton}
          autostartBooking={bookingButton?.autoStartBooking}
          quickAppointmentSetup={bookingButton?.quickAppointmentSetup}
          ignorePersistedData={ignorePersistedData}
      />
  );

  const oldBooking = (
      <BookingModalLegacy
          closeModal={closeModal}
          isOpen={isModalOpened}
          disableBooking={bookingButton.disableBooking}
          modalThemeColor={bookingButton.modalThemeColor}
          showCloseButton={bookingButton?.showCloseButton}
          autostartBooking={bookingButton?.autoStartBooking}
          ignorePersistedData={ignorePersistedData}
      />
  );

  return getBookingVersion();
};
